export interface BatchSchoolStatisticsAdvancementRequest {
  users: {
    id: string
    studentGrade: string
    studentClass: string
    studentNumber: string
  }[]
}

export function BatchSchoolStatisticsAdvancementRequestToJSON(
  value: BatchSchoolStatisticsAdvancementRequest
): any {
  return {
    users:
      value.users.length > 0
        ? value.users.map(user => ({
            id: user.id !== '' ? user.id : undefined,
            student_grade:
              user.studentGrade !== '' ? user.studentGrade : undefined,
            student_class:
              user.studentClass !== '' ? user.studentClass : undefined,
            student_number:
              user.studentNumber !== '' ? user.studentNumber : undefined
          }))
        : undefined
  }
}
